import React from 'react'
import './footer.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLinkedin,
  faGithub,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

const Footer = () => {
  return (
    <div className="social-footer">
      <a
        href="https://github.com/ElleeDev"
        target="_blank"
        rel="noreferrer"
        aria-label="GitHub"
      >
        <FontAwesomeIcon icon={faGithub} />
      </a>
      <a
        href="https://www.linkedin.com/in/ella-lee-dekel/"
        target="_blank"
        rel="noreferrer"
        aria-label="LinkedIn"
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </a>

      <a
        href="https://www.youtube.com/channel/UCUU7GIUD0Vj5_0JoeueXfAA"
        target="_blank"
        rel="noreferrer"
        aria-label="YouTube"
      >
        <FontAwesomeIcon icon={faYoutube} />
      </a>
    </div>
  )
}

export default Footer
